<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import UserMenu from './UserMenu'

export default {
  name: 'MainHeader',
  components: { UserMenu },
  data: () => ({
    logoIsSmall: false
  }),

  computed: {
    ...mapState(['user', 'showDraftsInGrid', 'menu', 'curTag', 'navState']),
    ...mapGetters(['pageRouteByTitle']),
    allowEdit () {
      return !!this.user && (this.user.role === 'admin' || this.user.role === 'editor')
    },
    title () {
      const routName = this.$route.name
      switch (routName) {
        case 'home':
        case 'drafts':
        case 'trash':
          return 'Aleksander Komarov'
        case 'about':
          return 'Contact / CV'
      }
      return ''
    },
    adminOrEditor () {
      return !!this.user && (this.user.role === 'admin' || this.user.role === 'editor')
    },
    admin () {
      return this.user && this.user.role === 'admin'
    },
    showPostFilters () {
      return !!this.user
    },
    showDraftsMessage () {
      return this.showDraftsInGrid ? 'Hide Drafts' : `Show ${!this.adminOrEditor ? 'Mine ' : ''}Drafts`
    },
    messageToggleDrafts () {
      return this.showDraftsInGrid ? 'Hide Drafts' : `Show ${!this.adminOrEditor ? 'Mine ' : ''}Drafts`
    }
  },

  created () {
    window.addEventListener('scroll', this.setLogoSize)
    window.addEventListener('resize', this.setLogoSize)
  },

  methods: {
    ...mapActions(['logOut', 'toggleDraftsInGrid', 'showEditor', 'setNavState']),
    toggleNavState () {
      const newState = this.navState === 'off' ? 'on' : 'off'
      this.setNavState(newState)
    },
    openEditor () {
      if (!this.allowEdit) return
      this.showEditor({ type: 'cv', value: 'cv' })
    },
    setLogoSize () {
      if (!this.$refs['logo-box']) return
      const style = getComputedStyle(document.documentElement)
      const mainH = style.getPropertyValue('--logo-main-height')
      const rem = 16 // px
      const mainHpx = parseFloat(mainH) * rem
      if (window.scrollY > mainHpx / 4) {
        if (!this.logoIsSmall) {
          this.$refs['logo-box'].classList.add('small')
          this.logoIsSmall = true
        }
      } else {
        if (this.logoIsSmall) {
          this.$refs['logo-box'].classList.remove('small')
          this.logoIsSmall = false
        }
      }
      if (this.logoIsSmall) return
      requestAnimationFrame(() => {
        if (!this.$refs['logo-box'] || !this.$refs.logo) return
        const s = window.scrollY
        const curScale = style.getPropertyValue('--logo-current-scale')
        const startH = parseFloat(mainH) * rem
        const endH = 3 * rem
        const t = s / (startH - endH)
        let scale = 1
        if (t < 1) {
          const curH = startH * (1 - t) + endH * t
          scale = curH / startH
        } else {
          scale = endH / startH
        }
        if (curScale !== `${scale}`) {
          document.documentElement.style.setProperty('--logo-current-scale', `${scale}`)
        }
      })
    }
  }
}
</script>

<template>
  <header ref="header" class="main-header items-center w-full">
    <button class="nav-state-toggle" :class="navState" @click="toggleNavState">Menu</button>
    <h3 class="uppercase flex items-center">
      <router-link :to="{ name: 'cv' }">Aleksander Komarov</router-link>
      <button v-if="allowEdit" class="compact top-right" @click="openEditor">
        <i class="material-icons text-base">edit</i>
      </button>
    </h3>
    <user-menu class="user-menu">
      <template v-if="showPostFilters">
        <a @click.prevent="toggleDraftsInGrid"
          class="nav-item secondary-item ml-auto select-none text-xs leading-none cursor-pointer">
          <span>{{ messageToggleDrafts }}</span>
        </a>
      </template>
      <slot />
    </user-menu>
  </header>
</template>

<style lang="scss">
.main-header {
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  padding: 0;
  /* padding-left: var(--base-padding); */
  z-index: 200;
  pointer-events: none;

  &>* {
    pointer-events: auto;
  }

  .nav-state-toggle {
    filter: blur(5px);
    transition: filter 0.3s ease-in-out;
    &.off, &:hover, &:focus-visible {
      filter: none;
    }
  }

  .login {
    flex-shrink: 0;
    margin-left: auto;
    pointer-events: auto;
  }
}

.user-actions {
  padding: calc(var(--base-padding) / 2);
}
</style>
